import React, { useState, useEffect, useContext } from 'react';
import classnames from 'classnames';

import { useWindowStore, useConfigStore, useMapStateStore, useMapInteractionStore } from '../../../../stores';
import SiteSeeContext from '../../../SiteSeeGuides/SiteSeeContext';
import { getPulseTarget, PULSE_TARGETS } from '../../../SiteSeeGuides/SiteSeeGuideData';

import ConditionalWrapperDivs from '../../../HelperComponents/ConditionalWrapperDivs';
import { ReactComponent as MarkersIcon } from './MarkersIcon.svg';
import { ReactComponent as HideMarkersIcon } from './HideMarkersIcon.svg';
import { ReactComponent as MobileMarkersIcon } from './MobileMarkersIcon.svg';
import { ReactComponent as MobileHideMarkersIcon } from './MobileHideMarkersIcon.svg';

import '../MapControls.scss';

const MapControlsMarkersToggle = () => {
  const [ markersToggleVisible, setMarkersToggleVisible ] = useState( false );

  // Zustand stores
  const isMobile = useWindowStore((state) => state.isMobile);
  const mapConfig = useConfigStore((state) => state.mapConfig);
  const featureFlags = useConfigStore((state) => state.featureFlags);
  const activeMapType = useMapStateStore((state) => state.activeMapType);
  const POIVisible = useMapStateStore((state) => state.POIVisible);
  const activeZoom = useMapStateStore((state) => state.activeZoom);

  const { siteSeeGuideId, siteSeeGuideMode } = useContext(SiteSeeContext);
  const isPulsing = isMobile && siteSeeGuideMode === 'tour' && getPulseTarget(siteSeeGuideId, isMobile) === PULSE_TARGETS.MARKERS;

  const { googleMapsConfig } = mapConfig || {};
  const { enableLevels: mapZoomToEnableLevels } = googleMapsConfig?.zooms || {};
  const { platformShowMapPlaceLabelsInitially } = featureFlags || {};

  // Map interaction store
  const markersVisible = useMapInteractionStore((state) => state.markersVisible);
  const setMarkersVisible = useMapInteractionStore((state) => state.setMarkersVisible);

  // Show the markers initially?
  useEffect( () => {
    if ( platformShowMapPlaceLabelsInitially ) {
      setMarkersVisible( true );
    }
  }, [ platformShowMapPlaceLabelsInitially ] );

  // Show/hide
  useEffect( () => {
    if ( mapZoomToEnableLevels && activeZoom ) {
      if ( activeZoom >= mapZoomToEnableLevels ) {
        setMarkersToggleVisible( true );
      } else {
        setMarkersToggleVisible( false );
      }
    }
  }, [
    mapZoomToEnableLevels,
    activeZoom,
  ] );

  const disabled = !markersToggleVisible || POIVisible || activeMapType === 'hybrid';

  return (
    <div
      id="mapControlsMarkersToggle"
      className={
        classnames( {
          mapControlToggle: !isMobile,
          mobileMapControl: isMobile,
          'mapControlToggle--disabled': !isMobile && disabled,
          'mobileMapControl--disabled': isMobile && disabled,
          'mobileMapControl--pulsing': isPulsing,
        } )
      }
    >
      <ConditionalWrapperDivs
        condition={ isMobile }
        classNamesArray={ [ 'mobileMapControl__toggleOptions mobileMapControl__toggleOptions--markers' ] }
      >
        <button
          type="button"
          className={
            classnames( {
              'mapControlToggle-toggleOption': !isMobile,
              mobileMapControl__toggleOption: isMobile,
              'mapControlToggle-toggleOption--show': !isMobile && !markersVisible,
              'mobileMapControl__toggleOption--hide': isMobile && markersVisible,
            } )
          }
          onClick={(e) => {
            e.currentTarget.blur();
            setMarkersVisible( true );
          }}
        >
          { isMobile ? <MobileMarkersIcon className="mobileMapControl__svg mobileMapControl__svg--markers" /> : <MarkersIcon /> }
        </button>

        <button
          type="button"
          className={
            classnames( {
              'mapControlToggle-toggleOption': !isMobile,
              mobileMapControl__toggleOption: isMobile,
              'mapControlToggle-toggleOption--show': !isMobile && markersVisible,
              'mobileMapControl__toggleOption--hide': isMobile && !markersVisible,
            } )
          }
          onClick={(e) => {
            e.currentTarget.blur();
            setMarkersVisible( false );
          }}
        >
          { isMobile ? <MobileHideMarkersIcon className="mobileMapControl__svg mobileMapControl__svg--markers" /> : <HideMarkersIcon /> }
        </button>
      </ConditionalWrapperDivs>
    </div>
  );
};

export default MapControlsMarkersToggle;
